import React, { useMemo } from 'react'
import * as Presenter from './HostSignUpPagePresenter'
import LoginBox from 'components/organisms/LoginBox'
import HostSignUpForm from 'components/organisms/HostSignUpForm'
import HostAndGuestSignUpForm from 'components/organisms/HostAndGuestSignUpForm'

const HostSignUpPage = ({
  account,
  onSubmitHost,
  onSubmitGuestAndHost,
  onChange,
  config,
  actions,
  viewer,
  canSubmit,
}) => {
  // ゲストアカウントのみを持っているかの判定
  const hasOnlyGuestAccount = useMemo(() => {
    // ホストアカウントを持っているかの判定
    const hasOwnerAccount = viewer?.owners?.results[0]?.username
    // ゲストアカウントを持っているかの判定
    const hasGuestAccount = viewer?.name
    return hasGuestAccount && !hasOwnerAccount
  }, [viewer])
  const loginBoxComponent = useMemo(() => {
    if (hasOnlyGuestAccount) return null
    return <LoginBox config={config} />
  }, [config, hasOnlyGuestAccount])
  const hostSignUpFormComponent = useMemo(() => {
    return (
      <HostSignUpForm
        account={account}
        onSubmit={onSubmitHost}
        onChange={onChange}
        actions={actions}
        canSubmit={canSubmit}
      />
    )
  }, [account, onSubmitHost, onChange, canSubmit])
  const hostAndGuestSignUpFormComponent = useMemo(() => {
    return (
      <HostAndGuestSignUpForm
        config={config}
        account={account}
        onSubmit={onSubmitGuestAndHost}
        onChange={onChange}
        actions={actions}
        canSubmit={canSubmit}
      />
    )
  }, [account, onSubmitGuestAndHost, onChange, canSubmit])

  // 以下の条件によって、表示するコンポーネントの出し分けを行う
  // 1. ゲストアカウントを持っている/ホストアカウントを持っていない
  // 2. ゲストアカウント・ホストアカウントを持っていない
  // 条件の出し分けは、hasOnlyGuestAccount で判定する
  const signUpFormComponent = hasOnlyGuestAccount
    ? hostSignUpFormComponent
    : hostAndGuestSignUpFormComponent

  return (
    <Presenter.HostSignUpPage
      loginBoxComponent={loginBoxComponent}
      signUpFormComponent={signUpFormComponent}
    />
  )
}

export default HostSignUpPage
